import { FORGET_ACTION, LOGIN_ACTION, STATUS } from "../constant";

const initState = {
  data: null,
  otpData: null
};
export default function login(state = initState, action) {
  switch (action.type) {
    case LOGIN_ACTION.LOGIN_START:
      return { ...state, loginStatus: STATUS.LOADING };
    case LOGIN_ACTION.LOGIN_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loginStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.LOGIN_FAILURE:
      return { ...state, loginStatus: STATUS.ERROR };
    case LOGIN_ACTION.LOGIN_CLEAR: {
      return {
        ...state,
        data: null,
        loginStatus: STATUS.CLEAR
      };
    }

    case LOGIN_ACTION.KEYCLOAK_LOGIN_START:
      return { ...state, loginStatus: STATUS.LOADING };
    case LOGIN_ACTION.KEYCLOAK_LOGIN_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        loginStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.KEYCLOAK_LOGIN_FAILURE:
      return { ...state, loginStatus: STATUS.ERROR };
    case LOGIN_ACTION.KEYCLOAK_LOGIN_CLEAR: {
      return {
        ...state,
        data: null,
        loginStatus: STATUS.CLEAR
      };
    }

    case LOGIN_ACTION.SECURITY_START:
      return { ...state, getSecurityKeyStatus: STATUS.LOADING };
    case LOGIN_ACTION.SECURITY_SUCCESS: {
      return {
        ...state,
        securityKeyData: action.payload,
        getSecurityKeyStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.SECURITY_FAILURE:
      return { ...state, getSecurityKeyStatus: STATUS.ERROR };

    case LOGIN_ACTION.OTP_START:
      return { ...state, otpStatus: STATUS.LOADING };
    case LOGIN_ACTION.OTP_SUCCESS: {
      return {
        ...state,
        otpData: action.payload,
        otpStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.OTP_FAILURE:
      return { ...state, otpStatus: STATUS.ERROR };

    case LOGIN_ACTION.OTP_MSG_CLEAR:
      return { ...state, otpStatus: null };

    case FORGET_ACTION.FORGET_START:
      return { ...state, forgetStatus: STATUS.LOADING };
    case FORGET_ACTION.FORGET_SUCCESS: {
      const { res } = action;
      return {
        ...state,
        forgetData: res.data,
        forgetStatus: STATUS.SUCCESS
      };
    }
    case FORGET_ACTION.FORGET_FAILURE:
      return { ...state, forgetStatus: STATUS.ERROR };
    case LOGIN_ACTION.LOGOUT_START:
      return { ...state, logoutStatus: STATUS.LOADING };
    case LOGIN_ACTION.LOGOUT_SUCCESS: {
      return {
        ...state,
        logoutStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.LOGOUT_FAILURE:
      return { ...state, logoutStatus: STATUS.ERROR };
    case LOGIN_ACTION.LOGIN_REQUEST_START:
      return { ...state, loginRequestStatus: STATUS.LOADING };
    case LOGIN_ACTION.LOGIN_REQUEST_SUCCESS: {
      return {
        ...state,
        loginRequestData: action.payload,
        loginRequestStatus: STATUS.SUCCESS
      };
    }
    case LOGIN_ACTION.LOGIN_REQUEST_FAILURE:
      return { ...state, loginRequestStatus: STATUS.ERROR };
    default:
      return state;
  }
}
